import { useState } from 'react';

/** Start screen shown before the game begins. */
export function IdleScreen({
  onStart, onStartFromTier, lastDeathTier,
  onCharacter, onShop, onEnhancement, onLeaderboard, onSettings,
}) {
  const [showModal, setShowModal] = useState(false);

  const handleStartClick = () => {
    if (lastDeathTier > 0) {
      setShowModal(true);
    } else {
      onStart();
    }
  };

  const resumeTier = Math.max(0, lastDeathTier - 3);

  return (
    <div className="overlay">
      <h1>Path of Survivor</h1>
      <p className="idle-subtitle">Dash Quest — survive as long as you can</p>
      <p className="controls">
        Move <kbd>🖱 Hold Click</kbd> / <kbd>↑↓←→</kbd>
        &nbsp;·&nbsp; Attack <kbd>Q</kbd>
        &nbsp;·&nbsp; Dash <kbd>E</kbd>
        &nbsp;·&nbsp; Block <kbd>W</kbd>
        &nbsp;·&nbsp; Potion <kbd>R</kbd>
        &nbsp;·&nbsp; Spells <kbd>1–4</kbd>
        &nbsp;·&nbsp; Pause <kbd>ESC</kbd>
      </p>
      <div className="idle-buttons">
        <button onClick={handleStartClick}>Start Game</button>
        <button className="btn-secondary" onClick={onCharacter}>Character</button>
        <button className="btn-secondary" onClick={onShop}>Talents</button>
        <button className="btn-secondary" onClick={onEnhancement}>Crafting</button>
        <button className="btn-secondary" onClick={onLeaderboard}>Leaderboard</button>
        <button className="btn-secondary" onClick={onSettings}>Settings</button>
      </div>

      {showModal && (
        <div className="start-modal-backdrop" onClick={() => setShowModal(false)}>
          <div className="start-modal" onClick={e => e.stopPropagation()}>
            <h2>Start Run</h2>
            <p className="start-modal-sub">Last run ended at tier {lastDeathTier}</p>
            <div className="start-modal-buttons">
              <button
                className="start-modal-btn start-modal-btn--primary"
                onClick={() => { setShowModal(false); onStart(); }}
              >
                ▶ New Run
                <span className="start-modal-hint">Start from Tier 0</span>
              </button>
              <button
                className="start-modal-btn start-modal-btn--resume"
                onClick={() => { setShowModal(false); onStartFromTier(resumeTier); }}
              >
                ⏩ Continue
                <span className="start-modal-hint">Start from Tier {resumeTier}</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
